import { render } from "./GameTwoWinView.vue?vue&type=template&id=4c9ec95a"
import script from "./GameTwoWinView.vue?vue&type=script&lang=js"
export * from "./GameTwoWinView.vue?vue&type=script&lang=js"

import "./GameTwoWinView.vue?vue&type=style&index=0&id=4c9ec95a&lang=css"

import exportComponent from "C:\\src\\Inmersys\\tres-prima\\mundo-zac-webapp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__